import { Link } from '@tanstack/react-router';
import { TeaCupIllustration } from '../components/illustrations.tsx';
import { Button } from '../components/ui/button.tsx';

export function NotFoundRoute() {
  return (
    <main className="max-w-md mx-auto px-6 py-24 text-center">
      <TeaCupIllustration className="size-28 mx-auto mb-4" />
      <p className="text-[64px] font-heading font-bold text-fg-3 mb-2">404</p>
      <h1 className="font-heading text-[22px] font-bold text-fg mb-2">Страница не найдена</h1>
      <p className="text-fg-2 text-[15px] mb-6">Возможно, она была удалена или вы перешли по неверной ссылке.</p>
      <Link to="/">
        <Button>Вернуться домой</Button>
      </Link>
    </main>
  );
}
